import "../assets/loading-style.css";
const Loading = () => {
  return <div className="loader"></div>;
};
export default Loading;
